"use client";
import * as React from "react";
import { Body } from "components/parts/Typography";
import type { BlogPostAuthorType } from "types/blog-type";
import {
  AuthorList,
  AuthorContainer,
  AuthorDetails,
  AuthorImgContainer,
  FeaturedContributorsListContainer
} from "./style";
import NextLink from "components/parts/NextLink";
import { mixpanelClient } from "analytics/mixpanel";
import Image from "next/image";
import { contentfulLoader } from "utils/images/contentfulLoader";
import { useRouter } from "i18n/routing";

interface FeaturedContributorsListProps {
  title: string;
  featuredAuthors: BlogPostAuthorType[];
}

const FeaturedContributorsList = ({
  title,
  featuredAuthors
}: FeaturedContributorsListProps) => {
  const router = useRouter();

  const handleLinkClick = (e: any, author: BlogPostAuthorType) => {
    e.preventDefault();
    mixpanelClient.track("Featured blog contributor/author click", {
      authorName: author.authorName,
      id: author.id
    });
    router.push(`blog/author/${author.slug}`);
  };

  return (
    <FeaturedContributorsListContainer>
      <Body size="md" semiBold m="0" mb="24px">
        {title.toUpperCase()}
      </Body>
      <AuthorList>
        {featuredAuthors.map((author) => (
          <AuthorContainer key={author.id}>
            <AuthorImgContainer>
              <Image
                src={author.profileImage.url}
                alt={author.profileImage.alt}
                width={64}
                height={64}
                loader={contentfulLoader}
                style={{ borderRadius: "50%" }}
              />
            </AuthorImgContainer>
            <AuthorDetails>
              <NextLink href="#">
                <div onClick={(e) => handleLinkClick(e, author)}>
                  <Body size="md" m="0" semiBold>
                    {author.authorName}
                  </Body>
                  <Body size="md" m="0" color={"secondary"}>
                    {author.authorPosition}
                  </Body>
                </div>
              </NextLink>
            </AuthorDetails>
          </AuthorContainer>
        ))}
      </AuthorList>
    </FeaturedContributorsListContainer>
  );
};

export default FeaturedContributorsList;
